import { frameworkIdentifierFormatter } from "./identifier.js";
const nextJsFormatters = [frameworkIdentifierFormatter];
export {
  nextJsFormatters
};
//# sourceMappingURL=formatters.client.js.map
